export default "__VITE_ASSET__BWSC7btJ__"